import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

export const SITE_URL = process.env.REACT_APP_SITE_URL || window.location.origin;

const META = {
  "/": [
    "Open Horizon Records - Original Music & Bespoke Songs",
    "Discover original music, albums and singles from Open Horizon Records. Commission personalised songs for weddings, birthdays, anniversaries and special moments.",
  ],
  "/music": [
    "Original Songs, Albums & Singles - Open Horizon Records",
    "Explore the Open Horizon Records catalogue: the nine-track album Every Season Leaves a Mark plus original singles, with 60-second previews, lyrics and streaming links.",
  ],
  "/news": [
    "Latest Music News & Releases - Open Horizon Records",
    "Release announcements, album stories and the latest news from independent music label Open Horizon Records.",
  ],
  "/bespoke": [
    "Personalised Songs & Bespoke Music from £99 - Open Horizon Records",
    "Create a personalised song from your own story with Open Horizon Records. Original lyrics, professional music production and bespoke song packages from £99.",
  ],
  "/about": [
    "About Open Horizon Records - Independent Music Label",
    "The story and values of Open Horizon Records — an independent music label creating original, story-driven songs and bespoke music.",
  ],
  "/press": [
    "Open Horizon Records - Press Kit & Radio Information",
    "Press biography, logo and artwork downloads, plus contact for radio presenters, playlist curators and journalists.",
  ],
  "/contact": [
    "Contact Open Horizon Records - Music & Song Enquiries",
    "Get in touch with Open Horizon Records about releases, radio airplay, press or commissioning a bespoke song.",
  ],
  "/discover": [
    "Discover Open Horizon Records - Original Music, Worldwide",
    "Independent record label creating and distributing original music worldwide — original singles and albums plus a bespoke songwriting service for life's biggest moments.",
  ],
};

export const RouteSeo = () => {
  const { pathname } = useLocation();
  const m = META[pathname];
  if (!m) return null;
  const canonical = `${SITE_URL}${pathname}`;
  return (
    <Helmet>
      <title>{m[0]}</title>
      <meta name="description" content={m[1]} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={m[0]} />
      <meta property="og:description" content={m[1]} />
      <meta property="og:url" content={canonical} />
    </Helmet>
  );
};

export const Seo = ({ title, description, path, jsonLd, image }) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <link rel="canonical" href={`${SITE_URL}${path}`} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={`${SITE_URL}${path}`} />
    {image && <meta property="og:image" content={image} />}
    {image && <meta name="twitter:card" content="summary_large_image" />}
    {image && <meta name="twitter:title" content={title} />}
    {image && <meta name="twitter:description" content={description} />}
    {image && <meta name="twitter:image" content={image} />}
    {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
  </Helmet>
);
